module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_first.1487221e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_first.png
// module id = 3471
// module chunks = 11